export enum OfftakerCardinality {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE'
}
